import _ from 'lodash';
import {
  parseAmount,
  friendlyDate,
  friendlyTime,
  friendlyDateTime,
  getTimeFromDateTime,
  simpleDateNoTime,
} from 'app/utils/parsers';
import IApplicationState from 'app/types/state';

// NOT BEING USED - CHECK PAYMENT EVENTS
function parsePaymentStatusText(
  status = 'pending',
  otherTeamStatus = 'pending',
) {
  let parsedText = 'Unpaid';
  if (status === 'paid') {
    parsedText = 'Teammo';
  }
  if (status === 'walkover' || otherTeamStatus === 'walkover') {
    parsedText = 'Forfeit';
  }
  if (status === 'no-show' || otherTeamStatus === 'no-show') {
    parsedText = 'No-show';
  }
  if (status === 'cancelled') {
    parsedText = 'Cancelled';
  }
  if (status === 'paid-cash') {
    parsedText = 'Cash';
  }
  if (status === 'paid-eftpos') {
    parsedText = 'Eftpos';
  }
  if (status === 'paid-prepaid') {
    parsedText = 'Pre-paid';
  }
  return parsedText;
}

function parsePaymentStatusColour(
  status = 'pending',
  otherTeamStatus = 'pending',
) {
  let parsedColour = 'grey';
  if (status === 'paid') {
    parsedColour = 'purple';
  }
  if (status === 'cancelled') {
    parsedColour = 'black';
  }
  if (status === 'no-show') {
    parsedColour = 'black';
  }
  if (status === 'paid-cash') {
    parsedColour = 'grey';
  }
  if (status === 'paid-eftpos') {
    parsedColour = 'blue';
  }
  if (status === 'paid-prepaid') {
    parsedColour = 'yellow';
  }
  if (status === 'pending') {
    parsedColour = 'grey';
  }
  if (status === 'walkover' || otherTeamStatus === 'walkover') {
    parsedColour = 'black';
  }
  return parsedColour;
}

function parsePaymentStatus(status = 'pending', otherTeamStatus = 'pending') {
  const statuses = [];
  const colour = parsePaymentStatusColour(status, otherTeamStatus);
  const text = parsePaymentStatusText(status, otherTeamStatus);

  if (text === 'Teammo' || text === 'Cash' || text === 'Eftpos' || 'Pre-paid') {
    statuses.push({ colour: 'green', text: 'Paid' });
  }
  statuses.push({ colour, text });

  return statuses;
}

interface IPaymentCardData {
  fixtureMatchId: string;
  paymentCollectionId: string;
  round: string;
  dateTime: string;
  eventInfo: string;
  amount: string;
  section: string;
  time: string;
  location: string;
  statuses: [
    {
      colour: string;
      text: string;
    }
  ];
  status: string;
  otherTeamStatus: string;
  metadata: any;
  paymentCategory: string;
}

function getFixtureMatchForGroup(fixtureMatch, groupId) {
  let groupData = {};
  if (_.isEmpty(fixtureMatch.groupOne) || _.isEmpty(fixtureMatch.groupTwo)) {
    return {};
  }
  if (fixtureMatch.groupOne.id === groupId) {
    const paymentCollectionId = fixtureMatch.groupOnePaymentStatus === 'walkover'
      ? fixtureMatch.groupOneForfeitPaymentCollection.id
      : fixtureMatch.groupOnePaymentCollection.id;

    groupData = {
      name: fixtureMatch.groupOneName,
      amount: parseAmount(fixtureMatch.groupOnePaymentAmount),
      statuses: parsePaymentStatus(
        fixtureMatch.groupOnePaymentStatus,
        fixtureMatch.groupTwoPaymentStatus,
      ),
      status: fixtureMatch.groupOnePaymentStatus,
      otherTeamStatus: fixtureMatch.groupTwoPaymentStatus,
      paymentCollectionId,
      fixtureMatchId: fixtureMatch.id,
      metadata: fixtureMatch.groupOnePaymentMetadata,
      paymentCategory: fixtureMatch.groupOnePaymentCategory,
    };
  }
  if (fixtureMatch.groupTwo.id === groupId) {
    const paymentCollectionId = fixtureMatch.groupTwoPaymentStatus === 'walkover'
      ? fixtureMatch.groupTwoForfeitPaymentCollection.id
      : fixtureMatch.groupTwoPaymentCollection.id;

    groupData = {
      name: fixtureMatch.groupTwoName,
      amount: parseAmount(fixtureMatch.groupTwoPaymentAmount),
      statuses: parsePaymentStatus(
        fixtureMatch.groupTwoPaymentStatus,
        fixtureMatch.groupOnePaymentStatus,
      ),
      status: fixtureMatch.groupTwoPaymentStatus,
      otherTeamStatus: fixtureMatch.groupOnePaymentStatus,
      paymentCollectionId,
      fixtureMatchId: fixtureMatch.id,
      metadata: fixtureMatch.groupTwoPaymentMetadata,
      paymentCategory: fixtureMatch.groupTwoPaymentCategory,
    };
  }
  return groupData;
}

export function getCurrentFixtureMatch(state) {
  if (
    state.fixtureMatches.fixtureMatchesById !== undefined
    && state.fixtureMatches.currentFixtureMatchId !== undefined
  ) {
    const findFixtureMatch = state.fixtureMatches.fixtureMatchesById[
      state.fixtureMatches.currentFixtureMatchId
    ];
    const currentFixtureMatch = {
      ...findFixtureMatch,
    };

    return currentFixtureMatch;
  }
  return {};
}

function getFixtureMatchesByIdSortedDate(fixtureMatchesById): any {
  if (fixtureMatchesById !== undefined) {
    const sortedFixtureMatchesById = {};
    const fixtureMatchesArray = _.map(
      fixtureMatchesById,
      (fixtureMatch) => fixtureMatch,
    );
    const sortedArray = fixtureMatchesArray.sort(
      (a, b) => new Date(b.eventAt) - new Date(a.eventAt),
    );
    _.each(sortedArray, (pe) => {
      sortedFixtureMatchesById[pe.id] = pe;
    });
    return sortedFixtureMatchesById;
  }
  return {};
}

export function getFixtureMatchesByIdSortedDateFilterByStatus(
  fixtureMatchesById,
  groupId,
  status = 'all',
): any {
  if (fixtureMatchesById !== undefined) {
    const filteredFixtureMatchesById = _.filter(fixtureMatchesById, (event) => {
      const groupData = getFixtureMatchForGroup(event, groupId);
      switch (status) {
        case 'pending':
          return (
            _.includes(['pending'], groupData.status)
            && !_.includes(['walkover'], groupData.otherTeamStatus)
          );
        case 'paid':
          return (
            _.includes(
              [
                'paid',
                'paid-cash',
                'paid-eftpos',
                'paid-prepaid',
                'paid-transferred',
              ],
              groupData.status,
            ) && !_.includes(['walkover'], groupData.otherTeamStatus)
          );
        case 'refunded':
          return (
            _.includes(['refunded'], groupData.status)
            && !_.includes(['walkover'], groupData.otherTeamStatus)
          );
        case 'forfeited':
          return (
            _.includes(['walkover'], groupData.status)
            || _.includes(['walkover'], groupData.otherTeamStatus)
          );
        case 'cancelled':
          return event.status === 'cancelled';
        case 'all':
          return true;
        default:
          return true;
      }
    });

    return getFixtureMatchesByIdSortedDate(filteredFixtureMatchesById);
  }
  return {};
}

export function getFixtureMatches(state) {
  return {
    ...state.fixtureMatches,
    currentFixtureMatch: {
      ...getCurrentFixtureMatch(state),
    },
    fixtureMatchesByIdSortedDate: getFixtureMatchesByIdSortedDate(
      state.fixtureMatches.fixtureMatchesById,
    ),
  };
}

export function getFixtureMatchesByIds(fixtureMatchesById, fixtureMatchIds) {
  if (fixtureMatchesById !== undefined && fixtureMatchIds != null) {
    return _.pick(fixtureMatchesById, fixtureMatchIds);
  }
  return {};
}

export function getFixtureMatchesByObjectId(
  fixtureMatchesById,
  object,
  objectId,
) {
  if (fixtureMatchesById !== undefined && objectId != null) {
    // console.log(fixtureMatches, objectId);
    const filteredFixtureMatches = _.filter(fixtureMatchesById, {
      [object]: { id: objectId },
    });

    const fixtureMatchIds = _.map(filteredFixtureMatches, 'id');
    const newFixtureMatchesById = _.pick(fixtureMatchesById, fixtureMatchIds);

    return {
      fixtureMatchesById: newFixtureMatchesById,
      fixtureMatchIds,
    };
  }
  return {};
}

export function getFixtureMatchForMatchCard(
  fixtureMatch,
  groupId,
): IPaymentCardData {
  const groupData = getFixtureMatchForGroup(fixtureMatch, groupId);

  if (_.isEmpty(groupData)) {
    return undefined;
  }
  return {
    fixtureMatchId: groupData.fixtureMatchId,
    paymentCollectionId: groupData.paymentCollectionId,
    round: fixtureMatch.description,
    dateTime: friendlyDate(fixtureMatch.eventAt),
    eventInfo: fixtureMatch.eventInfo,
    amount: groupData.amount,
    section: fixtureMatch.sectionTag,
    time: friendlyTime(fixtureMatch.eventAt),
    location: fixtureMatch.locationInfo,
    statuses: groupData.statuses,
    status: groupData.status,
    otherTeamStatus: groupData.otherTeamStatus,
    paymentCategory: groupData.paymentCategory,
    metadata: groupData.metadata,
  };
}
export function getGroupName(fixtureMatch, groupId): string {
  const groupData = getFixtureMatchForGroup(fixtureMatch, groupId);

  if (_.isEmpty(groupData)) {
    return undefined;
  }
  return groupData.name;
}

export function getFixtureMatchForDashboard(fixtureMatch) {
  if (!_.isEmpty(fixtureMatch)) {
    const summaryTime = friendlyDateTime(fixtureMatch.eventAt);
    let status = 'Unpaid';

    if (fixtureMatch.status !== 'active') {
      status = fixtureMatch.status;
    }
    if (
      (fixtureMatch.groupOnePaymentStatus === "paid" ||
        fixtureMatch.groupOnePaymentStatus === "paid-cash" ||
        fixtureMatch.groupOnePaymentStatus === "paid-prepaid" ||
        fixtureMatch.groupOnePaymentStatus === "paid-eftpos" ||
        fixtureMatch.groupOnePaymentStatus === "paid-transferred") &&
      (fixtureMatch.groupTwoPaymentStatus === "paid" ||
        fixtureMatch.groupTwoPaymentStatus === "paid-cash" ||
        fixtureMatch.groupTwoPaymentStatus === "paid-prepaid" ||
        fixtureMatch.groupTwoPaymentStatus === "paid-eftpos" ||
        fixtureMatch.groupOnePaymentStatus === "paid-transferred")
    ) {
      status = "Paid";
    }

    if (
      ((fixtureMatch.groupOnePaymentStatus === "paid" ||
        fixtureMatch.groupOnePaymentStatus === "paid-cash" ||
        fixtureMatch.groupOnePaymentStatus === "paid-prepaid" ||
        fixtureMatch.groupOnePaymentStatus === "paid-eftpos" ||
        fixtureMatch.groupOnePaymentStatus === "paid-transferred") &&
        !(
          fixtureMatch.groupTwoPaymentStatus === "paid" ||
          fixtureMatch.groupTwoPaymentStatus === "paid-cash" ||
          fixtureMatch.groupTwoPaymentStatus === "paid-prepaid" ||
          fixtureMatch.groupTwoPaymentStatus === "paid-eftpos" ||
          fixtureMatch.groupOnePaymentStatus === "paid-transferred"
        )) ||
      (!(
        fixtureMatch.groupOnePaymentStatus === "paid" ||
        fixtureMatch.groupOnePaymentStatus === "paid-cash" ||
        fixtureMatch.groupOnePaymentStatus === "paid-prepaid" ||
        fixtureMatch.groupOnePaymentStatus === "paid-eftpos" ||
        fixtureMatch.groupOnePaymentStatus === "paid-transferred"
      ) &&
        (fixtureMatch.groupTwoPaymentStatus === "paid" ||
          fixtureMatch.groupTwoPaymentStatus === "paid-cash" ||
          fixtureMatch.groupTwoPaymentStatus === "paid-prepaid" ||
          fixtureMatch.groupTwoPaymentStatus === "paid-eftpos" ||
          fixtureMatch.groupOnePaymentStatus === "paid-transferred"))
    ) {
      status = "Partially Paid";
    }

    if (
      fixtureMatch.status === 'cancelled' || fixtureMatch.groupOnePaymentStatus === 'cancelled'
      || fixtureMatch.groupTwoPaymentStatus === 'cancelled'
    ) {
      status = 'Cancelled';
    }

    if (
      fixtureMatch.groupOnePaymentStatus === 'no-show'
      || fixtureMatch.groupTwoPaymentStatus === 'no-show'
    ) {
      status = 'No-show';
    }

    if (
      fixtureMatch.groupOnePaymentStatus === 'walkover'
      || fixtureMatch.groupTwoPaymentStatus === 'walkover'
    ) {
      status = 'Forfeit';
    }
    const groupOnePaymentText = parsePaymentStatusText(
      fixtureMatch.groupOnePaymentStatus,
    );
    const groupTwoPaymentText = parsePaymentStatusText(
      fixtureMatch.groupTwoPaymentStatus,
    );

    let groupOnePaymentCollectionId;
    let groupTwoPaymentCollectionId;
    if (
      fixtureMatch
      && fixtureMatch.groupOnePaymentCollection !== undefined
      && fixtureMatch.groupTwoPaymentCollection !== undefined
      && fixtureMatch.groupOnePaymentCollection !== null
      && fixtureMatch.groupTwoPaymentCollection !== null
    ) {
      groupOnePaymentCollectionId = fixtureMatch.groupOnePaymentCollection.id;
      groupTwoPaymentCollectionId = fixtureMatch.groupTwoPaymentCollection.id;
    }
    const eventObject = {
      status,
      groupOnePaymentCollectionId,
      groupTwoPaymentCollectionId,
      groupOneName: fixtureMatch.groupOneName,
      groupTwoName: fixtureMatch.groupTwoName,
      groupOnePaymentData: {
        metadata: fixtureMatch.groupOnePaymentMetadata,
        paymentType: fixtureMatch.groupOnePaymentCategory,
        amount: parseAmount(fixtureMatch.groupOnePaymentAmount),
        forfeitAmount: parseAmount(fixtureMatch.groupOnePaymentForfeitAmount),
        receiptReference: fixtureMatch.groupOnePaymentReceiptReference,
        datePaid: simpleDateNoTime(fixtureMatch.groupOnePaymentPaidAt),
      },
      groupTwoPaymentData: {
        metadata: fixtureMatch.groupTwoPaymentMetadata,
        paymentType: fixtureMatch.groupTwoPaymentCategory,
        amount: parseAmount(fixtureMatch.groupTwoPaymentAmount),
        forfeitAmount: parseAmount(fixtureMatch.groupTwoPaymentForfeitAmount),
        receiptReference: fixtureMatch.groupTwoPaymentReceiptReference,
        datePaid: simpleDateNoTime(fixtureMatch.groupTwoPaymentPaidAt),
      },
      groupOneChecked:
        fixtureMatch.groupOnePaymentStatus === "paid" ||
        fixtureMatch.groupOnePaymentStatus === "paid-cash" ||
        fixtureMatch.groupOnePaymentStatus === "paid-prepaid" ||
        fixtureMatch.groupOnePaymentStatus === "paid-eftpos",
      groupOnePaymentText,
      groupTwoChecked:
        fixtureMatch.groupTwoPaymentStatus === "paid" ||
        fixtureMatch.groupTwoPaymentStatus === "paid-cash" ||
        fixtureMatch.groupTwoPaymentStatus === "paid-prepaid" ||
        fixtureMatch.groupTwoPaymentStatus === "paid-eftpos",
      groupTwoPaymentText,
      eventSection: fixtureMatch.sectionTag,
      eventLocation: fixtureMatch.locationInfo,
      groupOnePaymentUrl: `${TEAMMO_PAY_APP_URL}/${fixtureMatch.groupOnePaymentCollectionReference}`,
      groupTwoPaymentUrl: `${TEAMMO_PAY_APP_URL}/${fixtureMatch.groupTwoPaymentCollectionReference}`,
      eventTime: summaryTime,
      reference: fixtureMatch.reference,
      id: fixtureMatch.id,
    };

    return eventObject;
  }
  return {};
}

export function getFixtureMatchesForDashboard(fixtureMatches) {
  if (fixtureMatches === undefined) {
    return [];
  }

  const fixtureMatchesByTime = {};

  _.map(fixtureMatches, (fixtureMatch) => {
    if (fixtureMatch !== undefined) {
      const time = getTimeFromDateTime(fixtureMatch.eventAt);
      const eventObject = getFixtureMatchForDashboard(fixtureMatch);
      if (time !== 'Invalid date') {
        if (fixtureMatchesByTime[time] === undefined) {
          fixtureMatchesByTime[time] = [];
        }
        fixtureMatchesByTime[time].push(eventObject);
      }
    }
  });
  const timeKeys = _.keys(fixtureMatchesByTime);
  const sortedTimeKeys = timeKeys.sort(
    (a, b) => new Date(`1970/01/01 ${_.replace(a, '.', ':')}`)
      - new Date(`1970/01/01 ${_.replace(b, '.', ':')}`),
  );

  const sortedFixtureMatchesByTime = {};
  _.map(sortedTimeKeys, (time) => {
    sortedFixtureMatchesByTime[time] = _.sortBy(fixtureMatchesByTime[time], 'id');
  });

  return sortedFixtureMatchesByTime;
}
function setSummaryCount(paymentData, status, amount) {
  if (amount !== null && status !== null) {
    let countPayments = 0;
    if (
      paymentData[status] !== undefined
      && paymentData[status][amount.toString()] !== undefined
    ) {
      countPayments = paymentData[status][amount.toString()] + 1;
    } else {
      countPayments = 1;
    }
    return _.set(paymentData, `${status}`, {
      [amount.toString()]: countPayments,
    });
  }

  return paymentData;
}

export function getFixtureMatchReport(fixtureMatchesById, fixtureMatchIds) {
  let paymentData = {};
  let event;

  _.map(fixtureMatchIds, (eventId) => {
    event = fixtureMatchesById[eventId];
    paymentData = setSummaryCount(
      paymentData,
      event.groupOnePaymentStatus,
      event.groupOnePaymentAmount,
    );
    paymentData = setSummaryCount(
      paymentData,
      event.groupTwoPaymentStatus,
      event.groupTwoPaymentAmount,
    );
  });

  const paymentDataArr = [];
  _.map(paymentData, (statusValue, statusKey) => {
    _.map(statusValue, (amountValue, amountKey) => {
      paymentDataArr.push({
        paymentMethod: parsePaymentStatusText(statusKey),
        numberOfPayments: amountValue,
        paymentRate: parseAmount(parseInt(amountKey, 10)),
        paymentTotal: parseAmount(parseInt(amountKey, 10) * amountValue),
      });
    });
  });
  return paymentDataArr;
}

export function getFixtureMatchesByIdInSelectFormat(fixtureMatches): any {
  const locations = _.uniq(
    _.remove(_.map(fixtureMatches, (n) => n.locationInfo)),
    (e) => e === undefined,
  );

  return _.map(locations, (l) => {
    if (l !== undefined) {
      return { id: l, name: l };
    }
  });
}
